/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Faq_Q6Inputs */

const en_csv_to_json_faq_q6 = /** @type {(inputs: Csv_To_Json_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it handle Windows line endings and multi line fields?`)
};

const ko_csv_to_json_faq_q6 = /** @type {(inputs: Csv_To_Json_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows 줄바꿈과 여러 줄 필드를 처리하나요?`)
};

const ja_csv_to_json_faq_q6 = /** @type {(inputs: Csv_To_Json_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows の改行と複数行フィールドを扱えますか`)
};

/**
* | output |
* | --- |
* | "Does it handle Windows line endings and multi line fields?" |
*
* @param {Csv_To_Json_Faq_Q6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_faq_q6 = /** @type {((inputs?: Csv_To_Json_Faq_Q6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Faq_Q6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_faq_q6(inputs)
	if (locale === "ko") return ko_csv_to_json_faq_q6(inputs)
	return ja_csv_to_json_faq_q6(inputs)
});